















































import Vue from "vue"
import {ShipmentDeskDelivery} from "@/model/entity/shipment/shipment-desk-delivery"
import {CreateParcelModel} from "@/model/new-parcel-model/create-parcel-model"

export interface IDeskDeliveryGroup extends Vue {
  getDeskDelivery(): ShipmentDeskDelivery

  setDeskDelivery(shipmentDeskDelivery: ShipmentDeskDelivery): void

  clearAll(): void
}

export default Vue.extend({
  data() {
    return {
      form: {
        building: "",
        department: "",
        floor: 1
      },
      rules: {
        building: [{
          required: true, message: this.$t("new.parcel.error.desk_delivery.building").toString(),
          trigger: "change"
        }],
        department: [{
          required: true, message: this.$t("new.parcel.error.desk_delivery.department").toString(),
          trigger: "change"
        }]
      }
    }
  },
  props: {
    createParcelModel: {
      type: CreateParcelModel,
      required: true
    },
    deskDeliveryValidated: {
      type: Boolean,
      required: true
    },
    hasProductVariant: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clearAll() {
      this.form = {
        building: "",
        department: "",
        floor: 1
      }
    },
    getDeskDelivery(): ShipmentDeskDelivery {
      return new ShipmentDeskDelivery(this.form.floor.toString(), this.form.building, this.form.department)
    },
    setDeskDelivery(shipmentDeskDelivery: ShipmentDeskDelivery) {
      this.form.floor = Number(shipmentDeskDelivery.floor)
      this.form.building = shipmentDeskDelivery.building
      this.form.department = shipmentDeskDelivery.department
    },
    emitValidation() {
      this.$emit(
        "update:deskDeliveryValidated",
        !this.createParcelModel.createParcelModelOptions.deskDelivery.value ||
        (exists(this.form.building) &&
          this.form.building !== "" &&
          exists(this.form.department) &&
          this.form.department !== "" &&
          this.createParcelModel.createParcelModelOptions.deskDelivery.value)
      )
    }
  },
  watch: {
    "form.building": {
      handler() {
        this.emitValidation()
      }
    },
    "form.department": {
      handler() {
        this.emitValidation()
      }
    },
    "createParcelModel.createParcelModelOptions.deskDelivery.value": {
      handler() {
        this.emitValidation()
      }
    }
  },
  mounted() {
    this.emitValidation()
  }
})
